import http from '@http';
import createRequestParams from '../request/requestParamsFactory';
import { isEmpty } from 'lodash/core';
import contentTypeConfigurer from '../request/contentTypeConfigurer';

export const singleRequestServiceFactory = (endpoint) => {
    return async (fields, options) => {
        const requestParams = createRequestParams(contentTypeConfigurer.setField(fields),
                contentTypeConfigurer.setValue(options)),
            pathParams = requestParams.pathParams,
            queryParams = requestParams.queryParams;

        const httpOptions = {
            url: '{protocol}://' + endpoint,
            pathParameters: pathParams,
            queryParameters: queryParams
        };

        const bodyParams = requestParams.postParams;

        if (isEmpty(bodyParams)) {
            return http.get(httpOptions);
        } else {
            httpOptions.bodyParameters = bodyParams;
            return http.post(httpOptions);
        }
    };
};
